type FormatCurrencyType = {
  value: string | number;
  currency?: string;
  maximumFractionDigits?: number;
};

const formatCurrency = ({ value, currency = 'USD', maximumFractionDigits = 0 }: FormatCurrencyType) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits }).format(
    typeof value === 'string' ? parseFloat(value) : value
  );

export default formatCurrency;
